import { render, staticRenderFns } from "./QuestionBox.vue?vue&type=template&id=4d3c4390&scoped=true"
import script from "./QuestionBox.vue?vue&type=script&lang=js"
export * from "./QuestionBox.vue?vue&type=script&lang=js"
import style0 from "./QuestionBox.vue?vue&type=style&index=0&id=4d3c4390&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c4390",
  null
  
)

/* custom blocks */
import block0 from "./QuestionBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports